export default __webpack_public_path__ + "static/media/NEW LOGO (1).e5a543b6.svg";